// shipping / billing tabs
$('#customer_details .toggles a').on('click', function (e) {
    e.preventDefault();
    $('#customer_details .toggles a, #customer_details .tab').removeClass('active');
    $(this).addClass('active');
    $($(this).attr('href')).addClass('active');
});

// optional fields
// $('.form-row .optional').each(function(){
//   let $destination = $(this).closest('.form-row').find('.woocommerce-input-wrapper');
//   $(this).detach().appendTo($destination);
//   $destination.find('input, textarea').addClass('is-optional');
// });

// shipping options
$('#shipping_method input').on('change', function () {
    $('#shipping_method li').removeClass('selected');
    $(this).closest('li').addClass('selected');
});

$('.method-toggle').on('click', function (e) {
    e.preventDefault();
    $(this).closest('li').toggleClass('active');
});

// fake coupon field
$('#checkout-coupon-ui .btn').on('click', function (e) {
    e.preventDefault();
    $('#coupon_code').val($('#checkout-coupon-field').val());
    $('#wc-checkout-coupon').submit();
});

// remove product
$b.on('click', '#order_review .cart-remove', function (e) {
    e.preventDefault();
    let product_id = $(this).data('product_id');
    let cart_item_key = $(this).data('item_key');

    $('.woocommerce-checkout-payment, .woocommerce-checkout-review-order-table').block({
        message: null,
        overlayCSS: {
            background: '#fff',
            opacity: 0.6
        }
    });

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
        data: {
            action: "product_remove",
            product_id: product_id,
            cart_item_key: cart_item_key
        },
        success: function (response) {
            if (!response || response.error) {
                return;
            }

            var fragments = response.fragments;

            // Replace fragments
            if (fragments) {
                $.each(fragments, function (key, value) {
                    $(key).replaceWith(value);
                });
            }
            jQuery('body').trigger('update_checkout');
        }
    });
});

// cart updates affecting the minicart
$(document.body).on('wc_fragments_refreshed', function () {
    var $el = $('.total-items-count');
    var itemsCount = $('.woocommerce-mini-cart-item').length;
    var label = itemsCount === 1 ? ' item' : ' items';
    if ($el.length) {
        $el.text(itemsCount + label);
    }
    $('#cart-link .count').text(itemsCount);
});
